import "./customer-profile-shared.scss";

import {
  TextInput,
  AlertBox,
  SelectInput,
} from "@life-line-lab/components-react";
import { Row, Col } from "antd";
import useCountriesList from "Hooks/countries-option.hook";
import useStatesList from "Hooks/states-option.hook";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface CustomerProfileAddressProps {
  error: any;
  input: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (value: string | string[], name: string) => void;
}

const CustomerProfileAddress: FC<CustomerProfileAddressProps> = (props) => {
  const { error, input, handleChange, handleSelectChange } = props || {};

  const stateOption = useStatesList(input?.country);
  const countryOption = useCountriesList();

  const { t } = useTranslation();

  return (
    <div className="customer-profile-address customer-profile-shared">
      <label className="inp-label inp-label--required">
        {t("label.registeredAddress").toUpperCase()}
      </label>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <TextInput
            isRequired={true}
            placeholder={t("txt.street1Example")}
            value={input?.street1}
            name="street1"
            onChange={handleChange}
          />
          <AlertBox text={error?.street1} />
        </Col>
        <Col span={24}>
          <TextInput
            isRequired={true}
            placeholder={t("txt.street2Example")}
            value={input?.street2}
            name="street2"
            onChange={handleChange}
          />
          <AlertBox text={error?.street2} />
        </Col>
        <Col span={24} lg={12}>
          <TextInput
            isRequired={true}
            placeholder={t("txt.postcode")}
            value={input?.postcode}
            name="postcode"
            onChange={handleChange}
          />
          <AlertBox text={error?.postcode} />
        </Col>
        <Col span={24} lg={12}>
          <TextInput
            isRequired={true}
            placeholder={t("txt.city")}
            value={input?.city}
            name="city"
            onChange={handleChange}
          />
          <AlertBox text={error?.city} />
        </Col>
        <Col span={24} lg={12}>
          <SelectInput
            showSearch
            options={stateOption}
            value={input?.state}
            isReadonly={!input?.country}
            name="state"
            placeholder={t("option.state")}
            onChange={(value: string | string[]) =>
              handleSelectChange(value, "state")
            }
          />
          <AlertBox text={error.state} />
        </Col>
        <Col span={24} lg={12}>
          <SelectInput
            showSearch
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
            }
            options={countryOption}
            value={input.country}
            name="country"
            placeholder={t("option.country")}
            onChange={(value: string | string[]) =>
              handleSelectChange(value, "country")
            }
          />
          <AlertBox text={error.country} />
        </Col>
      </Row>
    </div>
  );
};

export default CustomerProfileAddress;
